import React from 'react';
import * as styles from './styles.scss';

const PaymentsIcons = ({ className }) => (
    <div className={`${styles.carts}${className ? ` ${className}`: ''}`}>
        <div className={styles.visa} />
        <div className={styles.mastercard} />
        <div className={styles.amex} />
        <div className={styles.discover} />
        <div className={styles.paypal} />
    </div>
);

export default PaymentsIcons;
